import React from 'react';
import { Unit } from '../components/ServiceItem';
import { ProductItemProps } from '../models/Product';
import { Payment, Resource, ScheduleItemProps, ScheduleItemPropsBuilder } from '../models/Schedule';
import { SlotHour } from '../modules/slots';
import { DisplayTimes } from '../pages/DateTime';
import { PatientProps } from '../contexts/PatientContext';

export type useSchedulingMountProps = {
  changeSchedule: (schedule: ScheduleItemProps) => ScheduleItemProps;
  selectedSchedule: ScheduleItemProps | undefined;
};

export function useSchedulingMount({ changeSchedule, selectedSchedule }: useSchedulingMountProps) {
  const [schedule, setSchedule] = React.useState({} as ScheduleItemProps);

  const scheduleBuilder = ScheduleItemPropsBuilder(schedule);

  function addPatient(patientId: string) {
    setSchedule(scheduleBuilder.setPatient(patientId));
  }

  function addPatientFull(patientId: PatientProps) {
    setSchedule(scheduleBuilder.setPatientFull(patientId));
  }

  function addProduct(product: ProductItemProps) {
    setSchedule(scheduleBuilder.setProduct(product));
  }

  function addCareType(careType: string) {
    setSchedule(scheduleBuilder.setScheduleType({ careType }));
  }

  function addPayment(payment: Payment) {
    setSchedule(scheduleBuilder.setPayment(payment));
  }

  function resetPayment() {
    setSchedule(scheduleBuilder.setPayment(undefined));
  }

  function addUnit(props: { unit: Unit; localId: string }) {
    setSchedule(scheduleBuilder.setUnit(props.unit, props.localId));
  }

  function addSlotsOptions(selectedSlotOptions: SlotHour[]) {
    setSchedule(scheduleBuilder.setSlotsOptions(selectedSlotOptions));
  }

  function addResource(useResource: boolean, resource?: Resource) {
    setSchedule(scheduleBuilder.setResource(useResource, resource));
  }

  function addChannel(channel: string) {
    setSchedule(scheduleBuilder.setChannel(channel));
  }

  function addTime(time: DisplayTimes) {
    setSchedule(scheduleBuilder.setTime(time));
  }

  function updateSchedule() {
    changeSchedule({ ...selectedSchedule, ...scheduleBuilder.build() });
  }

  function validateSchedule() {
    changeSchedule(scheduleBuilder.validateSchedule());
  }

  function createMultipleSchedulesByProduct(products: ProductItemProps[]) {
    return products.map(item => {
      const scheduleBuilder = ScheduleItemPropsBuilder();
      return scheduleBuilder.setProduct(item);
    });
  }

  return {
    addUnit,
    addTime,
    schedule,
    addPatient,
    addProduct,
    addChannel,
    addPayment,
    addCareType,
    addResource,
    resetPayment,
    addPatientFull,
    updateSchedule,
    addSlotsOptions,
    validateSchedule,
    createMultipleSchedulesByProduct
  };
}
